export type RoleRequirement = 'ADMIN' | 'OWNER'

const ROLES_MEETING_REQUIREMENT: Record<RoleRequirement, ReadonlySet<string>> = {
  ADMIN: new Set(['OWNER', 'ADMIN']),
  OWNER: new Set(['OWNER']),
}

/** Finishes the sentence "Only workspace … can view this page." */
export const ROLE_REQUIREMENT_LABELS: Record<RoleRequirement, string> = {
  ADMIN: 'owners and admins',
  OWNER: 'owners',
}

export function meetsRoleRequirement(
  role: string | null,
  requirement: RoleRequirement,
): boolean {
  return role !== null && ROLES_MEETING_REQUIREMENT[requirement].has(role)
}

/** Items without a requirement are always kept; gated ones need a known, sufficient role. */
export function filterByRole<T extends { requiredRole?: RoleRequirement }>(
  items: T[],
  role: string | null,
): T[] {
  return items.filter(
    (item) => !item.requiredRole || meetsRoleRequirement(role, item.requiredRole),
  )
}
